import { PageService } from '../../../../../../../services/page.service';
import {
    Component,
    OnInit,
    ViewEncapsulation,
    EventEmitter,
    Input,
    Output
} from '@angular/core';
import { Helpers } from '../../../../../../../helpers';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseComponent } from '../../../../base.component';

@Component({
    selector: 'app-list-page',
    templateUrl: './list-page.component.html',
    encapsulation: ViewEncapsulation.None
})
export class ListPageComponent extends BaseComponent implements OnInit {
    pages: any;
    path: string;

    @Input() selectedPageId: string;
    @Input() routePath: string;
    @Input() publisherName: string;
    @Input() siteName: string;

    private _siteId: string;
    get siteId(): string {
        return this._siteId;
    }
    @Input()
    set siteId(siteId: string) {
        this._siteId = siteId;
        if (!this._siteId) {
            this.pages = [];
            return;
        }
        this.getPages(siteId, this.selectedPageId);
    }
    @Output() pageChange: EventEmitter<any> = new EventEmitter<any>();

    constructor(private pageService: PageService, private router: Router) {
        super();
        this.path = Helpers.getPath();
    }

    ngOnInit() { }
    getPages(siteId: string, selectedPageId: string = null) {
        Helpers.setLoading(true);
        this.pageService.list({ filterId: siteId }).subscribe(res => {
            this.pages = res.data;
            if (this.pages.length > 0) {
                var selected = false;
                if (selectedPageId != null) {
                    for (let i = 0; i < this.pages.length; i++) {
                        const page = this.pages[i];
                        if (selectedPageId == page.id) {
                            this.onSelect(selectedPageId);
                            selected = true;
                            break;
                        }
                    }
                }
                if (selectedPageId == null || selected === false)
                    this.onSelect(this.pages[0].id);
            } else {
                this.pageChange.emit({ id: null });
            }
            Helpers.setLoading(false);
        });
    }

    onSelect(pageId): void {
        let page = this.pages[0];
        if (pageId != null || pageId != this.pages[0].id) {
            this.pages.forEach(item => {
                if (item.id == pageId) {
                    page = item;
                }
            });
        }
        this.selectedPageId = pageId;
        this.pageChange.emit({ id: pageId, name: page != null ? page.name : null });
    }

    onClickCreatePage() {
        if (!this.siteId) return;
        this.router.navigate(['/' + this.path + '/inventory/page/create'], {
            queryParams: {
                siteId: this.siteId,
                siteName: this.siteName,
                publisherName: this.publisherName,
                returnUrl: this.routePath
            }
        });
    }

    onClickUpdate(pageId) {
        this.router.navigate(['/' + this.path + '/inventory/page/update', pageId], {
            queryParams: {
                siteId: this.siteId,
                siteName: this.siteName,
                publisherName: this.publisherName,
                returnUrl: this.routePath
            }
        });
    }

    deletePage(pageId: string) {
        this.swalService.confirmDelete().then(res => {
            if (res.value) {
                Helpers.setLoading(true);
                this.pageService.delete(pageId).subscribe(() => {
                    Helpers.setLoading(false);
                    this.getPages(this.siteId);
                    this.selectedPageId = null;
                    this.swalService.successDelete();
                });
            }
        });
    }
}



// WEBPACK FOOTER //
// /Users/creative/Documents/GitHub/makrooreservation/src/ui/src/app/theme/pages/default/shared/inventory/page/list-page/list-page.component.ts